export const STENCIL_ROUTE_CONTENT_STABILITY_MS = 100;
export const STENCIL_ROUTE_DEFAULT_CONTENT_SELECTOR = 'main';
export const STENCIL_ROUTE_BUSY_CONTENT_SELECTOR = '[aria-busy="true"], [role="progressbar"]';

export const STENCIL_ROUTE_CONTENT_OBSERVER_OPTIONS: MutationObserverInit = {
    attributes: true,
    childList: true,
    characterData: true,
    subtree: true,
};
